export interface RawShipmentSuspendNotification {
  enabledPath: string[]
}

export class ShipmentSuspendNotificationConfig {
  constructor(
    private raw: RawShipmentSuspendNotification
  ) {}

  enabledOn(path: string): boolean {
    return this.raw.enabledPath.includes(path)
  }
}
